module.exports = __webpack_public_path__ + "static/img/grab.6392ef78.png";